// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpZichanIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpZichanIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpZichanIconOutlined = function DrrpZichanIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpZichanIconOutlinedSvg
  }));
};

DrrpZichanIconOutlined.displayName = 'DrrpZichanIconOutlined';
export default React.forwardRef(DrrpZichanIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpZichanIconOutlined.js
// module id = 2585
// module chunks = 0